import { Control, Controller, RegisterOptions } from "react-hook-form";
import Select from "react-select";

import Icon from "../ui/icon";

export type OptionProps = {
  value: number;
  label: string;
};

export type MultiSelectProps = {
  options: OptionProps[];
  control: Control;
  isPending: boolean;
  name: string;
  label: string;
  rules?: RegisterOptions;
};

export default function MultiSelect({ options, isPending = true, control, name, label, rules }: MultiSelectProps) {
  return (
    <>
      <label htmlFor={name} className="form-label text-uppercase fw-semibold">
        {label.toUpperCase()}
      </label>

      {isPending ? (
        <Select isLoading isDisabled />
      ) : (
        <Controller
          name={name}
          control={control}
          rules={rules}
          render={({ field: { onChange, value, ref }, fieldState: { error } }) => (
            <div style={{ position: "relative" }}>
              <Select
                ref={ref}
                options={options}
                value={options.filter((option) => value?.includes(option.value))}
                onChange={(val) => onChange(val.map((c) => c.value))}
                instanceId={name}
                isMulti
                classNamePrefix="select"
                styles={{
                  control: (base) => ({
                    ...base,
                    borderColor: error ? "#dc3545" : base.borderColor,
                    boxShadow: error ? "0 0 0 0.2rem rgba(220,53,69,.25)" : base.boxShadow,
                    "&:hover": {
                      borderColor: error ? "#dc3545" : base.borderColor,
                    },
                  }),
                  valueContainer: (base) => ({
                    ...base,
                    flexWrap: "nowrap",
                    overflowX: "auto",
                    overflowY: "hidden",
                    whiteSpace: "nowrap",
                  }),
                  multiValue: (base) => ({
                    ...base,
                    marginRight: "0.25rem",
                    flexShrink: 0,
                  }),
                }}
              />

              {error && (
                <div
                  className="alert alert-warning py-2 px-3 mt-2 d-inline-flex align-items-center"
                  role="alert"
                  style={{ fontSize: "0.875rem" }}
                >
                  <Icon icon="exclamation-triangle-fill" me={2} />
                  {error.message}
                </div>
              )}
            </div>
          )}
        />
      )}
    </>
  );
}
